import Select from '@/components/molecules/Select';
import { listarIdentidadesGenero } from '@/services/autenticacaoService';
import { CSSProperties, Dispatch, SetStateAction } from 'react';
import { TextFieldSize } from '../TextField';

interface SelectIdentidadeGeneroProps {
  // @ts-expect-error Valor Generico
  // eslint-disable-next-line no-undef
  $errors: FieldErrors<T>;
  // @ts-expect-error Valor Generico
  // eslint-disable-next-line no-undef
  $field: ControllerRenderProps<T, 'tipoGeneroID'>;
  $selecionarIdentidadeGenero: Dispatch<SetStateAction<string>>;
  $opcoesIdentidadeGenero?: Array<{ id: string; label: string }>;
  selectSize?: TextFieldSize;
  styleConteudoDropdown?: CSSProperties;
}

export function recuperarLabelIdentidadeGenero({
  opcoesIdentidadeGenero,
  identidadeGeneroSelecionada,
}: {
  opcoesIdentidadeGenero: Array<{ id: string; label: string }>;
  identidadeGeneroSelecionada: string;
}) {
  if (!opcoesIdentidadeGenero || !identidadeGeneroSelecionada)
    return { label: undefined };
  return opcoesIdentidadeGenero?.find(
    (identidadeGenero) => identidadeGenero.id === identidadeGeneroSelecionada,
  );
}

export async function recuperarIdentidadesGenero({
  setOpcoesIdentidadeGenero,
}: {
  setOpcoesIdentidadeGenero: Dispatch<
    SetStateAction<Array<{ id: string; label: string }>>
  >;
}) {
  const identidadesGenerosFromServer = await listarIdentidadesGenero();
  const identidadeGeneroOpcaoFormatada = identidadesGenerosFromServer?.map(
    (identidadeGenero) => {
      return {
        id: identidadeGenero.tipoGeneroID,
        label: identidadeGenero.nome,
      };
    },
  );
  setOpcoesIdentidadeGenero(identidadeGeneroOpcaoFormatada);
  return identidadeGeneroOpcaoFormatada;
}

export default function SelectIdentidadeGenero(
  props: SelectIdentidadeGeneroProps,
) {
  const {
    $errors,
    $field,
    $selecionarIdentidadeGenero,
    $opcoesIdentidadeGenero,
    selectSize = 2,
    styleConteudoDropdown = {},
  } = props;

  return (
    <Select
      $size={selectSize}
      $obrigatorio={true}
      $label="Gênero"
      $placeholder="Selecione o seu gênero"
      $variant="surface"
      $name="tipoGeneroID"
      $color="neutral"
      $error={$errors?.tipoGeneroID?.message ?? ''}
      $value={$field.value}
      $selecionarOpcao={$selecionarIdentidadeGenero}
      $selectOptions={$opcoesIdentidadeGenero ?? []}
      styleConteudoDropdown={styleConteudoDropdown}
    />
  );
}
